import { FC } from "react";
import cx from "classnames";
import styles from "./button.module.scss";
import { useIsMobile } from "@/utils/useIsMobile";

export enum VDPButtonType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

interface IVDPButtonProps {
  type?: VDPButtonType;
  title: string;
  name: string;
  className: string;
  onClick: () => void;
  isMobile?: boolean;
}

const VDPButton: FC<IVDPButtonProps> = ({ type, title, name, className, onClick, isMobile }) => {
  const mobile = useIsMobile(768, isMobile);
  return (
    <button
      name={name}
      className={cx(styles.button, className, {
        [styles.primary]: type === VDPButtonType.PRIMARY,
        [styles.secondary]: type === VDPButtonType.SECONDARY || !type,
        [styles.mobile]: mobile,
      })}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default VDPButton;
